import React, { useEffect } from 'react'
import { Breadcrumbs, Layout } from '@components/common'
import Script from 'next/script'
import { useRouter } from 'next/router'

export default function StoreLocation() {
  const router = useRouter()

  useEffect(() => {
    if (router.isReady) {
      window.location.reload()
    }
  }, [])

  return (
    <div className="wrapper fit mb-12">
      <Breadcrumbs current="Store Locations" />
      <div data-stockist-widget-tag="u4097">Loading store locations ...</div>

      <Script id="stockist-snippet">
        {`
        // <![CDATA[
            (function(s,t,o,c,k){c=s.createElement(t);c.src=o;c.async=1;
              k=s.getElementsByTagName(t)[0];k.parentNode.insertBefore(c,k);
              })(document,'script','//stockist.co/embed/v1/widget.min.js');
            // ]]>
      `}
      </Script>

      <style jsx global>
        {`
          .stockist-search-filter-checkbox label {
            display: flex;
            align-items: center;
          }
          .stockist-search-filter-checkbox input {
            margin-top: 0px !important;
          }

          @media (max-width: 767px) {
            .stockist-side-panel,
            .stockist-map {
              position: unset !important;
            }
            .stockist-horizontal .stockist-side-panel {
              width: 100% !important;
            }
          }
        `}
      </style>
    </div>
  )
}

StoreLocation.Layout = Layout
